<sc-padding class="no-field-space">

  <sc-sub-title><sc-dictionary-label dictionaryKey="tmc-yard.messaging.ui.messaging-property-administration.general"></sc-dictionary-label></sc-sub-title>

  <ac-string-property propertyKey="tmc-yard.messaging.sendername"></ac-string-property>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-sub-title><sc-dictionary-label dictionaryKey="tmc-yard.messaging.ui.messaging-property-administration.global-connect"></sc-dictionary-label></sc-sub-title>

  <ac-string-property propertyKey="tmc-yard.messaging.globalconnect.apiKey"></ac-string-property>
  <sc-hint-legacy dictionaryKey="tmc-yard.messaging.ui.messaging-property-administration.globalconnect-apikey-hint"></sc-hint-legacy>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-sub-title><sc-dictionary-label dictionaryKey="tmc-yard.messaging.ui.messaging-property-administration.sms"></sc-dictionary-label></sc-sub-title>

  <ac-property-group propertyKey="tmc-yard.messaging.sms.enabled">
    <ac-string-property propertyKey="tmc-yard.messaging.sms.apiKey"></ac-string-property>
    <sc-hint-legacy dictionaryKey="tmc-yard.messaging.ui.messaging-property-administration.sms-apikey-hint"></sc-hint-legacy>
  </ac-property-group>

  <sc-content-spacer vertical></sc-content-spacer>
  <sc-sub-title><sc-dictionary-label dictionaryKey="tmc-yard.messaging.ui.messaging-property-administration.message-driver"></sc-dictionary-label></sc-sub-title>

  <sc-hint-legacy dictionaryKey="tmc-yard.messaging.ui.messaging-property-administration.message-driver-hint"></sc-hint-legacy>
  <ac-boolean-property propertyKey="tmc-yard.messaging.welcome-message.enabled"></ac-boolean-property>
  <ac-boolean-property propertyKey="tmc-yard.messaging.truck-detached-message.enabled"></ac-boolean-property>
  <ac-boolean-property propertyKey="tmc-yard.messaging.truck-and-trailer-detached-message.enabled"></ac-boolean-property>
  <ac-boolean-property propertyKey="tmc-yard.messaging.pause-start-message.enabled"></ac-boolean-property>
  <ac-boolean-property propertyKey="tmc-yard.messaging.pause-end-message.enabled"></ac-boolean-property>

</sc-padding>
